import { ReactFlowProvider } from "@xyflow/react";
import DiagramaCanvas from "./DiagramaCanvas";

// Entidade usada para vincular anexos a um nó do diagrama na tabela genérica Anexos
// (exportadas para o circuito/index.js usar exatamente os mesmos valores ao criar o anexo no save)
export const ANEXO_ENTITY_TYPE_NODE = "DiagramaEquipamentoNode";
export const ANEXO_TYPE_NODE = "equipamento";

// Wrapper do diagrama que provê o contexto ReactFlowProvider para o canvas; estado
// (diagrama/nodeAnexos) chega por props em vez de ref imperativo (Task 4 da
// hierarquia de circuitos) — quem instancia os hooks é circuito/index.js
export default function DiagramaEquipamentos({
  diagrama,
  nodeAnexos,
  diagramInstanceKey = "",
  editMode = false,
  isActive = true,
  isExpanded = false,
  onToggleExpanded = () => {},
  setSnackbar = () => {},
  circuitoPersisted = false,
  circuitoId = "",
  hostOptions = [],
  onSalvarCircuito,
  salvandoCircuito = false,
}) {
  return (
    <ReactFlowProvider>
      <DiagramaCanvas
        diagrama={diagrama}
        nodeAnexos={nodeAnexos}
        diagramInstanceKey={diagramInstanceKey}
        editMode={editMode}
        isActive={isActive}
        isExpanded={isExpanded}
        onToggleExpanded={onToggleExpanded}
        setSnackbar={setSnackbar}
        circuitoPersisted={circuitoPersisted}
        circuitoId={circuitoId}
        hostOptions={hostOptions}
        onSalvarCircuito={onSalvarCircuito}
        salvandoCircuito={salvandoCircuito}
      />
    </ReactFlowProvider>
  );
}
